<nav class="navbar navbar-expand-lg border-bottom navbar-bg-{{siglaMarca}}">
    <div class="container">
        <span class="logo">
          <img class="logo" src="../../../assets/images/logo_{{siglaMarca}}.png" alt="Logo da Marca"/>
        </span>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#nvbCollapse"
            aria-controls="nvbCollapse">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div *ngIf="exibeMenu" class="d-flex flex-row-reverse bd-highlight collapse navbar-collapse" id="nvbCollapse">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item pl-1">
                    <a class="nav-link" routerLink="/pesquisa"><i
                            class="fa fa-home fa-fw mr-1"></i><span>Inicio</span></a>
                </li>
                <!-- <li class="nav-item pl-1">
                    <a class="nav-link" href="#"><i class="fa fa-paper-plane fa-fw mr-1"></i><span>Enviar</span></a>
                </li> -->
                <li class="nav-item pl-1">
                    <a class="nav-link" (click)="close()" href="#"><i
                            class="fa fa-sign-in fa-fw mr-1"></i><span>Sair</span></a>
                </li>
            </ul>
        </div>
    </div>
</nav>
